export const PENDING = "PENDING";
export const RIGHT = "RIGHT";
export const WRONG = "WRONG";
